/**
* 报告
*/
const report = {
  
createReportGroup: "/api/createReportGroup",//创建报告组
modifyReportGroup: "/api/modifyReportGroup",//修改报告组
deleteReportGroup: "/api/deleteReportGroup",//删除报告组
getReportGroups: "/api/getReportGroups",//查询报告组
addReportAutomaticGeneratingConfig: "/api/addReportAutomaticGeneratingConfig",//增加自动生成报告配置
deleteReportAutomaticGeneratingConfig: "/api/deleteReportAutomaticGeneratingConfig",//删除自动生成报告配置
getReportAutomaticGeneratingConfigs: "/api/getReportAutomaticGeneratingConfigs",//查询自动生成报告配置
listReport: "/api/listReport",//获取报告列表
peekReport: "/api/peekReport",//获取报告内容
testReportByConfig: "/api/testReportByConfig",//测试报告内容
}

export default report